import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { changeLanguage, setSsoToken } from "../utils/globalSlice";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SecureLS from "secure-ls";

const Header = ({ image, altTxt }) => {
  const dispatch = useDispatch();
  const ls = new SecureLS({ encodingType: "aes" });
  //get language from store
  const lang = useSelector((state) => state.global.language);
  const isMob = useSelector((state) => state.global.isMobile);

  //get loggedin user data from store
  const loggedInUser = useSelector((state) => state.global.user);

  //get ssoToken from localstorage
  const lsSsoToken = ls.get("ssoToken");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [searchParams, setSearchParams] = useSearchParams();
  const carId = searchParams.get("carId");

  //handles click of menu in header (menu available only after logged in)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //handle sso authentication
  const handleSSO = () => {
    //get current url
    const currentUrl = window.location.href;

    const paramSymbol = carId ? "&" : "?";
    //define redirect url with current url and attatching token
    const redirectUrl = `https://www.fazaa.ae/account/signin?ssoReturnUrl=${encodeURIComponent(
      currentUrl + paramSymbol
    )}token=`;
    window.open(redirectUrl, "_self");
  };

  //function to handle signout, clears localstorage, sets sso token in store to null
  const handleSignOut = () => {
    ls.remove("ssoToken");
    dispatch(setSsoToken(""));
    handleClose();
  };

  //handles menu close
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box flexGrow={1}>
      <AppBar
        position="static"
        sx={{
          backgroundImage: `linear-gradient(45deg, #b48c24, #cbaf66)`,
        }}
      >
        <Toolbar>
          <Container
            maxWidth="xl"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ padding: ".5rem 0", maxWidth: "100px" }}>
              <Link to="/">
                <img src={image} alt={altTxt} width="100%" />
              </Link>
            </Box>
            <Stack direction={"row"} useFlexGap spacing={2}>
              {lang === "en" ? (
                <Button
                  variant="text"
                  color="white"
                  disableRipple
                  onClick={() => dispatch(changeLanguage("ar"))}
                >
                  العربية
                </Button>
              ) : (
                <Button
                  variant="text"
                  color="white"
                  disableRipple
                  onClick={() => dispatch(changeLanguage("en"))}
                >
                  English
                </Button>
              )}
              {/* {!lsSsoToken ? (
                <Button variant="contained" color="appBlue" onClick={handleSSO}>
                  <FormattedMessage id="app.button.signin" />
                </Button>
              ) : (
                <Stack
                  direction={"row"}
                  spacing={1}
                  useFlexGap
                  alignItems={"center"}
                >
                  <Button
                    variant="text"
                    color="appBlue"
                    onClick={handleClick}
                    size="large"
                    sx={{ color: "white.main" }}
                  >
                    <Stack
                      justifyContent={"flex-start"}
                      sx={{ textAlign: "left", ml: 1 }}
                      direction={isMob ? "column" : "row"}
                      spacing={1}
                      useFlexGap
                    >
                      <AccountCircleIcon sx={{ fontSize: "38px" }} />

                      {lang === "en" ? (
                        <Typography variant="body2" sx={{ maxWidth: "200px" }}>
                          {loggedInUser?.fullNameEn}
                        </Typography>
                      ) : (
                        <Typography variant="body2" sx={{ maxWidth: "200px" }}>
                          {loggedInUser?.fullNameAr}
                        </Typography>
                      )}
                    </Stack>
                  </Button>
                  <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem
                      onClick={handleSignOut}
                      sx={{ minWidth: "250px" }}
                    >
                      <FormattedMessage id="app.menu.logout" />
                    </MenuItem>
                  </Menu>
                </Stack>
              )} */}
            </Stack>
          </Container>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
